@let _state = state$ | async;

@if (_state?.variant) {
  <div
    class="app-payment-overdue-banner"
    [class.app-payment-overdue-banner--warning]="_state.variant === 'warning'"
    [class.app-payment-overdue-banner--danger]="_state.variant !== 'warning'">
    <app-svg
      class="app-payment-overdue-banner__icon"
      [src]="attentionIcon"
      [type]="'none'"
      [disabledHover]="true">
    </app-svg>

    <span class="b3-r t-not-capitalize">
      @switch (_state.variant) {
        @case ('suspended') {
          {{ 'pages.billing.overdueBanner.messageSuspended' | translate }}
        }
        @case ('lastDay') {
          {{ 'pages.billing.overdueBanner.messageLastDay' | translate }}
        }
        @default {
          @if (_state.daysLeft === 1) {
            {{ 'pages.billing.overdueBanner.messageSingular' | translate }}
          } @else {
            {{ 'pages.billing.overdueBanner.message' | translate: { days: _state.daysLeft } }}
          }
        }
      }
    </span>

    @if (canPay) {
      <a
        class="b3-r t-not-capitalize app-payment-overdue-banner__link"
        [routerLink]="'/billing'">
        {{ 'pages.billing.overdueBanner.payNow' | translate }}
      </a>
    }
  </div>
}
